import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { endpoints } from "@/api";
import { useAuth } from "@/auth";
import { useI18n } from "@/i18n";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t } = useI18n();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await endpoints.session(sessionId);
        setUser(user);
        // Clean hash and resume the path the user was trying to reach (if any)
        let next = "/recipes";
        try {
          const stored = sessionStorage.getItem("auth_next");
          if (stored && stored.startsWith("/")) next = stored;
          sessionStorage.removeItem("auth_next");
        } catch (_) { /* ignore */ }
        window.history.replaceState({}, document.title, "/");
        navigate(next, { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="max-w-md mx-auto p-20 text-center text-[#5C544F]" data-testid="auth-callback">
      {t.auth.signingIn}
    </div>
  );
}
